<div class="flex flex-col gap-2">
  @if (label()) {
    <label [for]="inputId()">{{ label() | translateKey }}</label>
  }

  <p-select
    [id]="inputId()"
    [options]="filteredOptions()"
    [optionLabel]="displayField()"
    [optionValue]="valueField()"
    [placeholder]="placeholderValue()"
    [filter]="filterable()"
    [filterBy]="displayField()"
    [filterPlaceholder]="filterPlaceholderValue()"
    [disabled]="disabled()"
    [loading]="loading()"
    [ngModel]="value()"
    (onChange)="onSelectChange($event)"
    (onBlur)="onBlur()"
    [ngClass]="{
      'ng-invalid ng-dirty': hasErrorSignal(),
      'w-full': fullWidth(),
    }"
    styleClass="w-full"
  />

  @if (hasErrorSignal()) {
    <app-form-field-error [controlName]="ngControl"></app-form-field-error>
  }
</div>
